<it-card teaser="true" shadow="true" *ngIf="actors?.length">
  <div class="row mb-3">
    <div class="col text-end">
      <a
        tabindex="0"
        role="button"
        popoverTrigger="focus"
        popoverTitle="Info"
        itPopover="Dal qui è possibile modificare la competenza associata alla pratica. Seleziona prima la ASL, successivamente la macrocategoria e il destinatario finale. Premendo il tasto Conferma, la pratica verrà aggiornata con la nuova competenza selezionata, modificando il campo 'in carico a'.">
        <it-icon name="info-circle" size="sm"></it-icon>
      </a>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col">
      <div class="mb-3">
        <it-select
          label="ASL"
          [(ngModel)]="selectedAslId"
          (ngModelChange)="onAslOrActorChange()"
          defaultOption="Seleziona la Asl"
          [disabled]="authService.isOperatoreSegnalante"
        >
          <option [ngValue]="null">Seleziona una ASL</option>
          <option *ngFor="let asl of asls" [value]="asl.id">{{ asl.name }}</option>
        </it-select>
      </div>

      <fieldset *ngIf="selectedAslId">
        <div class="form-check form-check-inline">
          <it-checkbox [(ngModel)]="cot" (ngModelChange)="onAslOrActorChange()" label="COT" [disabled]="authService.isOperatoreSegnalante"/>
        </div>
        <div class="form-check form-check-inline" *ngIf="request?.setting?.code == 'HCP'">
          <it-checkbox [(ngModel)]="uvm" (ngModelChange)="onAslOrActorChange()" label="UVCP" [disabled]="authService.isOperatoreSegnalante"/>
        </div>
        <div class="form-check form-check-inline" *ngIf="request?.setting?.code != 'HCP'">
          <it-checkbox [(ngModel)]="uvm" (ngModelChange)="onAslOrActorChange()" label="UVM" [disabled]="authService.isOperatoreSegnalante"/>
        </div>
        <div class="form-check form-check-inline">
          <it-checkbox [(ngModel)]="ward" (ngModelChange)="onAslOrActorChange()" label="REPARTI" [disabled]="authService.isOperatoreSegnalante"/>
        </div>
        <div class="form-check form-check-inline">
          <it-checkbox [(ngModel)]="pua" (ngModelChange)="onAslOrActorChange()" label="PUA" [disabled]="authService.isOperatoreSegnalante"/>
        </div>
        <div class="form-check form-check-inline">
          <it-checkbox [(ngModel)]="bedManager" (ngModelChange)="onAslOrActorChange()" label="BED MANAGER" [disabled]="authService.isOperatoreSegnalante"/>
        </div>
      </fieldset>

      <div class="mt-3" *ngIf="ownerships.length > 0">
        <div class="row mb-2">
          <div class="col">
            <it-input
              [(ngModel)]="searchTerm"
              placeholder="Filtra per nome o tipologia"
              (input)="filterOwnerships()"
              [disabled]="authService.isOperatoreSegnalante"
            ></it-input>
          </div>
          <div class="col-2" [class.d-grid]="false">
            <button
              [disabled]="searchTerm === '' || authService.isOperatoreSegnalante"
              [itButton]="'outline-danger'"
              [size]="'xs'"
              (click)="resetFilter()"
            >
              Annulla
            </button>
          </div>
        </div>

        <it-table compact="true">
          <ng-container thead>
            <tr>
              <th scope="col">Tipologia</th>
              <th scope="col">Nome</th>
            </tr>
          </ng-container>
          <ng-container tbody>
            <tr
              *ngFor="let o of filteredOwnerships"
              (click)="selectOwnership(o)"
              [class.table-primary]="o === selectedOwnershipId"
              style="cursor: pointer"
            >
              <td>{{ o.type }}</td>
              <td>{{ o.name }}</td>
            </tr>
          </ng-container>
        </it-table>
      </div>

      <div class="d-flex justify-content-end gap-2 mt-4">
        <button itButton="outline-primary" type="button" (click)="cancel()">Torna indietro</button>
        <button
          itButton="primary"
          type="button"
          [disabled]="!selectedOwnershipId"
          (click)="confirm()"
        >
          Conferma cambio competenza
        </button>
      </div>
    </div>
  </div>
</it-card>
